<template>
  <div class="overlay">
    <div class="loader">
      <div class="dot dot1" />
      <div class="dot dot2" />
      <div class="dot dot1" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "BarLoader",
});
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  display: flex;
  gap: 7px;
  align-items: flex-end;
}

.dot {
  width: 3px;
  border-radius: 1px;
  animation: wave 0.6s infinite ease-in-out;
  transform-origin: center center;
}

/* Individual delays to create wave effect */
.dot1 {
  animation-delay: 0s;
}
.dot2 {
  animation-delay: 0.3s;
}

@keyframes wave {
  0%,
  100% {
    background-color: #e7e6e6;
    height: 4px;
    transform: scaleY(1);
  }
  50% {
    background-color: #9f9f9f;
    height: 8px;
    transform: scaleY(2);
  }
}
</style>
